import { Injectable } from '@angular/core';
import { ComplexDialogHeaderComponent } from './templates/header/complex-dialog-header.component';
import { ComplexDialogFooterComponent } from './templates/footer/complex-dialog-footer.component';
import { ComplexDialogTemplateConfigurationService } from './complex-dialog-template-configuration.service';
import * as i0 from "@angular/core";
import * as i1 from "primeng/dynamicdialog";
export class ComplexDialogV3Service {
  dialogService;
  constructor(dialogService) {
    this.dialogService = dialogService;
  }
  open(complexDialogConfig, componentType) {
    const templateConfigService = new ComplexDialogTemplateConfigurationService(complexDialogConfig);
    const dataWithTemplateConfigService = {
      templateConfigService: templateConfigService,
      ...complexDialogConfig.data
    };
    const dialogConfig = {
      ...complexDialogConfig
    };
    dialogConfig.appendTo = 'body';
    dialogConfig.focusTrap = true;
    dialogConfig.data = dataWithTemplateConfigService;
    dialogConfig.templates = {
      header: ComplexDialogV3Service.buildHeaderTemplate(dialogConfig),
      footer: ComplexDialogV3Service.buildFooterTemplate(dialogConfig),
      ...complexDialogConfig.templates
    };
    return {
      ref: this.dialogService.open(componentType, dialogConfig),
      templateConfigService: templateConfigService
    };
  }
  dialogRefMap() {
    return this.dialogService.dialogComponentRefMap;
  }
  static buildFooterTemplate(complexDialogConfig) {
    return complexDialogConfig.templates?.footer ? complexDialogConfig.templates?.footer : ComplexDialogFooterComponent;
  }
  static buildHeaderTemplate(complexDialogConfig) {
    const usedHeaderTemplate = complexDialogConfig.templates?.header ? complexDialogConfig.templates?.header : ComplexDialogHeaderComponent;
    return !complexDialogConfig.hideHeader ? usedHeaderTemplate : undefined;
  }
  static ɵfac = function ComplexDialogV3Service_Factory(t) {
    return new (t || ComplexDialogV3Service)(i0.ɵɵinject(i1.DialogService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ComplexDialogV3Service,
    factory: ComplexDialogV3Service.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComplexDialogV3Service, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.DialogService
  }], null);
})();
